const Error = () => {
  return (
    <div data-testid="contractor-card-list-fallback-error">
      Error Selecting Contractor Information Category
    </div>
  );
};

export default Error;
